export const listColumnsSize = {
  title: null,
  duration: 2,
  type: 3,
  typeShort: 2,
};
